import urls from 'configs/urls';
import { convertObjectToQueryString } from 'utils/convert-object';
import { state } from 'react-beep';
import _ from 'lodash';

const getHeaders = () => {
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json; charset=utf-8',
    ...(state.token ? { Authorization: state.token } : {}),
  };
};

const request = async (url, options) => {
  let result;
  try {
    result = await fetch(url, {
      ...options,
      headers: getHeaders(),
    });
  } catch (e) {
    console.error(e);
  }

  if (result && result.status === 204) {
    return result;
  } else if (result && result.status === 400) {
    // ToasterNotify('اطلاعات فرستاده شده صحیح نمی باشد');

    return result.json();
  } else if (result && result.status === 401) {
    if (window.location.pathname !== '/') {
      window.location.replace('/');
      localStorage.clear();
    }
  } else if (result) {
    return await result.json();
  }
};

export const post = ({ api, model } = {}) => {
  model.user_type = _.get(state, 'profile.user_profile.user_type');
  return request(`${urls.endPointAdmin}${api}`, {
    method: 'POST',
    body: JSON.stringify(model),
  });
};

export const get = ({ api, model } = {}) => {
  return request(`${urls.endPointAdmin}${api}`, {
    method: 'GET',
  });
};

export const getWithQueryString = ({ api, model } = {}) => {
  const query = convertObjectToQueryString(model);
  // console.log({ query });
  return request(`${urls.endPointAdmin}${api}?${query}`, {
    method: 'GET',
  });
};

export const remove = ({ api, id } = {}) => {
  return request(`${urls.endPointAdmin}${api}/${id}`, {
    method: 'DELETE',
  });
};

export const removeWithModel = ({ api, model } = {}) => {
  return request(`${urls.endPointAdmin}${api}`, {
    method: 'DELETE',
    body: JSON.stringify(model),
  });
};

//FIXME: need determine entity id
export const put = ({ api, model } = {}) => {
  model.user_type = _.get(state, 'profile.user_profile.user_type');
  return request(`${urls.endPointAdmin}${api}`, {
    method: 'PUT',
    body: JSON.stringify(model),
  });
};

//FIXME: need determine entity id
export const patch = ({ api, model } = {}) => {
  model.user_type = _.get(state, 'profile.user_profile.user_type');
  return request(`${urls.endPointAdmin}${api}`, {
    method: 'PATCH',
    body: JSON.stringify(model),
  });
};
